import CloudOffRoundedIcon from '@mui/icons-material/CloudOffRounded'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'
import styled from 'styled-components'

import { Button } from '../ui'

export default function ServiceUnavailablePage({ isRetrying, retryError, onRetry }) {
  return (
    <Backdrop role="alert" aria-labelledby="service-unavailable-title">
      <Panel>
        <StatusIcon aria-hidden="true"><CloudOffRoundedIcon /></StatusIcon>
        <ErrorCode>500</ErrorCode>
        <h1 id="service-unavailable-title">akive 서버에 연결하지 못했어요</h1>
        <Description>요청에 대한 응답을 받지 못했어요.<br />서버 상태를 확인한 뒤 다시 연결해 주세요.</Description>
        <SupportText>
          문제가 계속되면 <a href="mailto:support@akive.net">support@akive.net</a>으로 알려 주세요.
        </SupportText>
        {retryError && <RetryError role="status">{retryError}</RetryError>}
        <Button disabled={isRetrying} onClick={onRetry}>
          <RefreshRoundedIcon aria-hidden="true" fontSize="small" />
          {isRetrying ? '연결 확인 중…' : '다시 연결'}
        </Button>
      </Panel>
    </Backdrop>
  )
}

const Backdrop = styled.div`
  position: fixed;
  z-index: 5000;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: ${({ theme }) => theme.colors.background};
`

const Panel = styled.main`
  width: min(100%, 680px);
  padding: clamp(36px, 7vw, 64px);
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.large};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.shadow.medium};

  h1 {
    margin: 14px 0 18px;
    color: ${({ theme }) => theme.colors.text};
    font-size: clamp(1.45rem, 3.4vw, 1.8rem);
    line-height: 1.35;
    white-space: nowrap;
    word-break: keep-all;
  }

  button {
    display: inline-flex;
    gap: 7px;
  }

  @media (max-width: 620px) {
    h1 { white-space: normal; }
  }
`

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.7;
`

const SupportText = styled.p`
  margin: 22px 0 32px;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.84rem;
  line-height: 1.6;

  a {
    color: ${({ theme }) => theme.colors.primaryAccent};
    font-weight: 700;
    text-decoration: none;
  }

  a:hover { text-decoration: underline; }
`

const StatusIcon = styled.div`
  display: grid;
  width: 54px;
  height: 54px;
  margin: 0 auto 18px;
  place-items: center;
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 18px;
  background: ${({ theme }) => theme.colors.primarySoft};

  svg { font-size: 28px; }
`

const ErrorCode = styled.span`
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.18em;
`

const RetryError = styled.div`
  margin: -16px 0 20px;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.84rem;
`
